import React from 'react';
import ContentWithNavigationSidebar from '../legacy/layouts/ContentWithNavigationSidebar';
// import TEST from '../telekardia/components/MicroComponent';
import Clinician from '../clinician/container/Microfrontend_component';
import ClinicianAdmin from '../clinician/container/Microfrontend_component_Admin';
import ROUTE_PATHS from './routePaths';

const Routes = [
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.CLINICIAN_HOME,
    component: p => (
      <ContentWithNavigationSidebar>
        <Clinician />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.CLINICIAN_REVIEW,
    component: p => (
      <ContentWithNavigationSidebar>
        <Clinician />
      </ContentWithNavigationSidebar>
    ),
  },

  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.CLINICIAN_ECGLIST,
    component: p => (
      <ContentWithNavigationSidebar>
        <Clinician />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.CLINICIAN_REPORT,
    component: p => (
      <ContentWithNavigationSidebar>
        <Clinician />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.CLINICIAN_RESOURCE,
    component: p => (
      <ContentWithNavigationSidebar>
        <Clinician />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.CLINICIAN_ADMIN_HOME,
    component: p => (
      <ContentWithNavigationSidebar>
        <ClinicianAdmin />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.CLINICIAN_ADMIN_ECGLIST,
    component: p => (
      <ContentWithNavigationSidebar>
        <ClinicianAdmin />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.CLINICIAN_ADMIN_REVIEW,
    component: p => (
      <ContentWithNavigationSidebar>
        <ClinicianAdmin />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.CLINICIAN_ADMIN_REPORT,
    component: p => (
      <ContentWithNavigationSidebar>
        <ClinicianAdmin />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.CLINICIAN_ADMIN_RESOURCE,
    component: p => (
      <ContentWithNavigationSidebar>
        <ClinicianAdmin />
      </ContentWithNavigationSidebar>
    ),
  },
];
export default Routes;



// WEBPACK FOOTER //
// ./src/routes/clinicianRoutes.jsx